// extracted by mini-css-extract-plugin
export default {"form":"styles_form__4dSjw","button":"styles_button__f4DSP","alert":"styles_alert__jUIVY","ok":"styles_ok__-0hfz"};